import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import logo from "@/assets/images/logo.svg";
import { divider } from "@/theme/colors";

type TLoginLogoProps = {};

export const LoginLogo: FC<TLoginLogoProps> = () => {
  return (
    <Stack gap={1} alignItems="center">
      <Stack>
        <img width={240} src={logo} alt="logo" />
      </Stack>
      <Stack alignItems="center" width={240} paddingY={1} borderTop={1} borderBottom={1} borderColor={divider.high}>
        <Typography variant="sub16Bold">自社支援</Typography>
      </Stack>
    </Stack>
  );
};
